/** Limits align with Laravel registration validators (max rules are in KB on the server). */

export const PROFILE_PHOTO_MAX_BYTES = 2048 * 1024;
export const ORG_LOGO_MAX_BYTES = 2048 * 1024;
export const ORG_BANNER_MAX_BYTES = 10240 * 1024;
export const VERIFICATION_DOC_MAX_BYTES = 2048 * 1024;
export const EVENT_COVER_MAX_BYTES = 5120 * 1024;

function fileExtension(name: string): string {
  const dot = name.lastIndexOf('.');
  return dot >= 0 ? name.slice(dot + 1).toLowerCase() : '';
}

/** Accept when MIME is missing (some browsers) if extension matches. */
export function validateProfilePhoto(file: File | null): string | null {
  if (!file) return null;
  const extOk = ['jpg', 'jpeg', 'png'].includes(fileExtension(file.name));
  const mimeOk =
    !file.type || file.type === 'image/jpeg' || file.type === 'image/png';
  if (!mimeOk && !extOk) return 'Profile photo must be JPG or PNG.';
  if (file.size > PROFILE_PHOTO_MAX_BYTES) return 'Profile photo must be 2 MB or smaller.';
  return null;
}

export function validateOrgLogo(file: File | null, required = false): string | null {
  if (!file) return required ? 'Organization logo is required.' : null;
  const extOk = ['jpg', 'jpeg', 'png', 'webp'].includes(fileExtension(file.name));
  const mimeOk =
    !file.type ||
    file.type === 'image/jpeg' ||
    file.type === 'image/png' ||
    file.type === 'image/webp';
  if (!mimeOk && !extOk) return 'Logo must be PNG, JPG, JPEG, or WEBP.';
  if (file.size > ORG_LOGO_MAX_BYTES) return 'Logo must be 2 MB or smaller.';
  return null;
}

export function validateOrgBanner(file: File | null): string | null {
  if (!file) return null;
  const extOk = ['jpg', 'jpeg', 'png', 'webp'].includes(fileExtension(file.name));
  const mimeOk =
    !file.type ||
    file.type === 'image/jpeg' ||
    file.type === 'image/png' ||
    file.type === 'image/webp';
  if (!mimeOk && !extOk) return 'Banner must be PNG, JPG, JPEG, or WEBP.';
  if (file.size > ORG_BANNER_MAX_BYTES) return 'Banner must be 10 MB or smaller.';
  return null;
}

export function validateVerificationDocument(file: File | null, required = false): string | null {
  if (!file) return required ? 'Verification document is required.' : null;
  const extOk = ['pdf', 'jpg', 'jpeg', 'png'].includes(fileExtension(file.name));
  const mimeOk =
    !file.type ||
    file.type === 'application/pdf' ||
    file.type === 'image/jpeg' ||
    file.type === 'image/png';
  if (!mimeOk && !extOk) return 'Verification document must be PDF, JPG, or PNG.';
  if (file.size > VERIFICATION_DOC_MAX_BYTES) return 'Verification document must be 2 MB or smaller.';
  return null;
}

export function validateEventCoverImage(file: File | null, required = false): string | null {
  if (!file) return required ? 'Featured image is required.' : null;
  const extOk = ['jpg', 'jpeg', 'png', 'webp'].includes(fileExtension(file.name));
  const mimeOk =
    !file.type ||
    file.type === 'image/jpeg' ||
    file.type === 'image/png' ||
    file.type === 'image/webp';
  if (!mimeOk && !extOk) return 'Featured image must be JPG, JPEG, PNG, or WEBP.';
  if (file.size > EVENT_COVER_MAX_BYTES) return 'Featured image must be 5 MB or smaller.';
  return null;
}
